import { useMemo } from "react";
import { graphql, useStaticQuery } from "gatsby";

export const useConfigData = () => {
  const response = useStaticQuery(
    graphql`
      {
        configDataCommon: allMarkdownRemark(
          filter: { frontmatter: { type: { eq: "website_config_common" } } }
        ) {
          edges {
            node {
              frontmatter {
                visit_main_item_en
                visit_main_item_nl
                visit_main_item_es
                visit_main_item_pt
                visit_main_item_ru
                visit_main_item_uk
                visit_main_item_fr
                terms_and_condition_en
                terms_and_condition_es
                terms_and_condition_pt
                terms_and_condition_ru
                terms_and_condition_uk
                terms_and_condition_fr
                terms_and_condition_nl
                privacy_policy_en
                privacy_policy_es
                privacy_policy_pt
                privacy_policy_ru
                privacy_policy_uk
                privacy_policy_fr
                privacy_policy_nl
                buy_main_item_en
                buy_main_item_nl
                buy_main_item_es
                buy_main_item_pt
                buy_main_item_ru
                buy_main_item_ru
                buy_main_item_fr
                visit_general_en
                visit_general_es
                visit_general_pt
                visit_general_ru
                visit_general_uk
                visit_general_fr
                visit_general_nl
                buy_general_en
                buy_general_es
                buy_general_pt
                buy_general_ru
                buy_general_uk
                buy_general_fr
                buy_general_nl
                title_structure_featured_editor_choice_homepage_en
                title_structure_featured_editor_choice_homepage_es
                title_structure_featured_editor_choice_homepage_pt
                title_structure_featured_editor_choice_homepage_ru
                title_structure_featured_editor_choice_homepage_uk
                title_structure_featured_editor_choice_homepage_fr
                title_structure_featured_editor_choice_homepage_nl
                title_structure_featured_shopping_A_homepage_en
                title_structure_featured_shopping_A_homepage_es
                title_structure_featured_shopping_A_homepage_pt
                title_structure_featured_shopping_A_homepage_ru
                title_structure_featured_shopping_A_homepage_uk
                title_structure_featured_shopping_A_homepage_fr
                title_structure_featured_shopping_A_homepage_nl
                title_structure_featured_travel_A_homepage_en
                title_structure_featured_travel_A_homepage_es
                title_structure_featured_travel_A_homepage_pt
                title_structure_featured_travel_A_homepage_ru
                title_structure_featured_travel_A_homepage_uk
                title_structure_featured_travel_A_homepage_fr
                title_structure_featured_travel_A_homepage_nl
                optimal_route_en
                optimal_route_fr
                optimal_route_pt
                optimal_route_es
                optimal_route_ru
                optimal_route_uk
                optimal_route_nl
                optimal_route_shopping_en
                optimal_route_shopping_fr
                optimal_route_shopping_pt
                optimal_route_shopping_es
                optimal_route_shopping_ru
                optimal_route_shopping_uk
                optimal_route_shopping_nl
                read_more_en
                read_more_es
                read_more_pt
                read_more_ru
                read_more_uk
                read_more_fr
                en_share
                fr_share
                es_share
                pr_share
                ru_share
                en_contact
                fr_contact
                es_contact
                pr_contact
                ru_contact
                booking_placeholder_map_widget
                booking_banner_home_horizontal
                booking_sidebar_vertical_banner_en
                en_emoji
                fr_emoji
                pt_emoji
                es_emoji
                ru_emoji
                uk_emoji
                nl_emoji
                whatsapp_share_image {
                  childImageSharp {
                    gatsbyImageData(layout: FIXED)
                  }
                }
                aca_logo {
                  childImageSharp {
                    gatsbyImageData(layout: FIXED)
                  }
                }
              }
            }
          }
        }
        configData: allMarkdownRemark(
          filter: { frontmatter: { type: { eq: "website_config" } } }
        ) {
          edges {
            node {
              frontmatter {
                i18n_main
                booking_sidebar_vertical_banner_en
                booking_banner_home_horizontal
                website_title_en
                website_title_fr
                website_title_es
                website_title_pt
                website_title_ru
                website_title_uk
                website_title_nl
                seo_meta_title_prefix_en
                seo_meta_title_prefix_es
                seo_meta_title_prefix_pt
                seo_meta_title_prefix_fr
                seo_meta_title_prefix_ru
                seo_meta_title_prefix_uk
                seo_meta_title_prefix_nl
                seo_meta_decription_en
                seo_meta_decription_fr
                seo_meta_decription_es
                seo_meta_decription_pt
                seo_meta_decription_ru
                seo_meta_decription_uk
                seo_meta_decription_nl
                seo_meta_keywords_en
                seo_meta_keywords_fr
                seo_meta_keywords_es
                seo_meta_keywords_pt
                seo_meta_keywords_ru
                seo_meta_keywords_uk
                seo_meta_keywords_nl
                amazon_custom_link
              }
            }
          }
        }
      }
    `
  );

  // const configData = {
  //   ...response.configData.edges[0].node.frontmatter,
  //   ...response.configDataCommon.edges[0].node.frontmatter,
  // };

  const mconfigData = useMemo(() => {
    // console.dir({
    //   FROM: "🧡🧡🧡🧡🧡🧡🧡🧡🧡🧡🧡🧡🧡🧡🧡🧡🧡🧡🧡🧡🧡",
    // });
    return {
      ...response.configData.edges[0].node.frontmatter,
      ...response.configDataCommon.edges[0].node.frontmatter,
    };
  }, [response]);

  return mconfigData;
};
